import { Row, Col, Space, Segmented, Button, Tooltip } from "antd";

import get from "lodash/get";

import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";

import { generateInjectionMouldingTimeGraphPdf } from "../../../utilities/pdf/injectionMouldingTimeGraphPdf";
import { getFileNameInitials } from "../../../utilities/helpers";

const GraphHeader = ({selectedTemplate, onChangeParams, setLoading, filter}) => {
  return (
        <Row justify={"end"} className="mt-2 mb-10">
        <Col>
          <Space>
            <Segmented
              className="bg-gray-200"
              options={[
                { label: "60 min", value: 60 },
                { label: "30 min", value: 30 },
              ]}
              value={get(selectedTemplate, "interval")}
              defaultValue={60}
              onChange={(interval) => {
                onChangeParams(
                  get(selectedTemplate, "template"),
                  interval,
                  get(selectedTemplate, "shift", "id")
                );
              }}
            />
            <Tooltip title="Refresh Statistics">
              <Button
                type="primary"
                icon={<ReloadOutlined />}
                onClick={() => {
                  onChangeParams(
                    get(selectedTemplate, "template"),
                    get(selectedTemplate, "interval"),
                    get(selectedTemplate, "shift")
                  );
                }}
              />
            </Tooltip>
            <Tooltip title="Download Report">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() =>
                  generateInjectionMouldingTimeGraphPdf(
                    selectedTemplate,
                    filter,
                    setLoading,
                    getFileNameInitials("time-graph", {
                      tempalteName: get(selectedTemplate, "template.name"),
                      shiftName: get(filter, "shift.name"),
                      companyName: get(filter, "company.name"),
                      date: get(filter, "date"),
                    })
                  )
                }
              />
            </Tooltip>
          </Space>
        </Col>
      </Row>
  )
}

export default GraphHeader